<div class="container-login grid grid-cols-1 md:grid-cols-3">
  <div
    class="hidden md:flex md:col-span-2 logo-container relative items-center justify-center"
  >
    <div class="circle-inner"></div>
    <div class="circle-outer"></div>
    <svg-icon svgClass="svgSize" src="assets/svg/logo-login.svg"></svg-icon>
  </div>
  <div class="w-full relative">
    <div class="absolute inset-x-0 top-10 flex justify-center md:hidden">
      <svg-icon svgClass="h-12 w-auto" src="assets/svg/logo-purple.svg"></svg-icon>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
